/**
 * Breedte van een formulierveld binnen de content-kolom van de horizontale layout.
 *
 * - `small`  → col-lg-3
 * - `medium` → col-lg-6
 * - `large`  → col-lg-9
 *
 * Niet ingesteld → volle breedte (col-lg-12).
 */
export type ColWidth = "small" | "medium" | "large";

const COL_WIDTH_CLASS: Record<ColWidth, string> = {
  small: "col-lg-3",
  medium: "col-lg-6",
  large: "col-lg-9",
};

/** Geeft de Bootstrap-kolomklasse voor de gegeven veldbreedte (col-lg-12 indien niet ingesteld). */
export function colWidthClass(colWidth?: ColWidth): string {
  return colWidth ? COL_WIDTH_CLASS[colWidth] : "col-lg-12";
}
